import { useEffect, useState } from 'react'
import { load } from '@fingerprintjs/botd'
import { logger } from '@/utils/logging'

export const useBotDetection = () => {
  const [isBot, setIsBot] = useState<boolean>(false)
  useEffect(() => {
    const detectBot = async () => {
      try {
        const botd = await load()
        const isBot = botd.detect()
        setIsBot(isBot?.bot ?? false)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        logger().error('botd library failed for an unknown reason', err)
        setIsBot(true)
      }
    }

    detectBot()
  }, [])
  return {
    isBot,
  }
}
